import { Flex } from 'antd';

import { Button } from '@suntex.fim/ui';

import * as images from '../../assets/family-link/images';

export function FamilyLinkBanner() {
  return (
    <Flex vertical gap={20} className="familylink__bannersection">
      <Flex align="center" justify="center" wrap className="familylink__banner">
        <images.FamilyLinklarge />
        <img src={images.FamilyLinkHero} alt="Family Link Hero" />
        <Flex vertical>
          <div className="familylink__banner-content">
            <h3 className="familylink__banner-head">
              Live math
              <br />
              at home.
            </h3>
            <p className="familylink__banner-para">
              Practice and improve <br /> math skills and see results <br />
              in just minutes a day.
            </p>
            <Flex>
              <h3 className="familylink__banner-label">FamilyLink</h3>
              <span className="familylink__banner-labellink">R</span>
            </Flex>
          </div>
          <Button
            intent="primary"
            href="https://explore.firstinmath.com/media/35221/fim-welcome-parents.pdf"
            target="_blank"
            className="family-link-pdf-btn"
          >
            Welcome Parent PDF
          </Button>
        </Flex>
      </Flex>
    </Flex>
  );
}
